import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from 'redux/store.types'

const qrCodeStateSelector = (state: RootState) => state.qrCodes

export const qrCodeAppearanceSelector = createSelector(
  qrCodeStateSelector,
  (state) => state.appearance,
)

export const qrFilenameSelector = createSelector(qrCodeStateSelector, (state) => state.filename)
export const qrUrlSelector = createSelector(qrCodeStateSelector, (state) => state.url)
export const qrBlobUrlSelector = createSelector(qrCodeStateSelector, (state) => state.blobUrl)
export const qrBlobSelector = createSelector(qrCodeStateSelector, (state) => state.blob)
